import { Suspense, useEffect } from 'react';
// Lazy identity shared with the router (views/lazyViews) — a static import
// here pulled the `three` chunk back onto the landing critical path (the A2
// Lazy3D leak, closed 2026-07-01). The chunk is idle-prefetched in main.tsx,
// so the Suspense fallback is effectively never seen in practice.
import { EditorView } from '@/views/lazyViews';
import { ViewerRouteFallback } from '@/components/ViewerRouteFallback';
import { supabase } from '@/lib/supabase';

import type { FullTab } from './tabModel';

export function EditorTabPane({
  conversationId,
  setTabs,
  isActive,
}: {
  conversationId: string;
  setTabs: React.Dispatch<React.SetStateAction<FullTab[]>>;
  isActive: boolean;
}) {
  useEffect(() => {
    supabase
      .from('conversations')
      .select('title')
      .eq('id', conversationId)
      .single()
      .then(({ data }) => {
        if (data?.title) {
          setTabs((prev) =>
            prev.map((t) =>
              t.conversationId === conversationId
                ? { ...t, title: data.title }
                : t,
            ),
          );
        }
      });
  }, [conversationId, setTabs]);

  return (
    <div className="h-full w-full overflow-hidden">
      <Suspense fallback={<ViewerRouteFallback />}>
        <EditorView conversationId={conversationId} isActive={isActive} />
      </Suspense>
    </div>
  );
}
